

    <div *ngIf="afdbZeroResultsMsg !== ''" class="threedViewer structureContainer ">
        <p *ngIf="hasAFDBData === -1 && totalAFDBStructure == 0" class="noRecMsg">{{ afdbZeroResultsMsg }}</p>
    </div>

    <div *ngIf="isDatabaseErrorATBC" class="threedViewer structureContainer ">
        <p *ngIf="hasAFDBData === -1" class="k36-i">There is an issue with this entry. Please report it to us at <a href="mailto:afdbhelp@ebi.ac.uk">afdbhelp&#64;ebi.ac.uk</a> and include the accession number you were trying to access.</p>
    </div>
    
    <div class="download-first-row" *ngIf="afdbZeroResultsMsg === '' && !isDatabaseErrorATBC">
        <div class="link-button-download" class="structureContainer-1">
            <div class="download-data nonMobile"  *ngIf="isAFDBDownloadEnabled === true && isAFDBLoading === false">
                <div  style="display: flex;" *ngIf="!downloadService.isDownloadRunningATBC() || downloadService.isDownloadFailedATBC()">
                    <app-file-download
                      [isWide]="true"
                      [dropdownOptions]="dropdownOptionsAFDB"
                      (selected)="handleDropdownSelection($event,'atbc')"
                      [selectedValues]="selectedValuesATBC()">
                    </app-file-download>
                    <div class="downloadselectedtext" *ngIf="selectedValuesATBC().length > 0"> 
                      <span class="maxselected selectedtext">{{ selectedValuesATBC().length }} selected (max {{ MAX_SELECTION }})</span> 
                      <a href="javascript:void(0)" (click)="clearSelectionDownload('afdb')" class="resetLink selectedtext clearselected">Clear selection</a>
                    </div>
                  </div>
                  <div *ngIf="downloadService.isDownloadRunningATBC() && !downloadService.isDownloadFailedATBC()" style="display: flex;" > 
                    <span style="display: inline-block; width: 20px; margin-left: 8px;">
                      <svg  width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" class="spinner_aj0A" stroke="#707372" fill="#707372" />
                      </svg>
                    </span> <span class="selectedtext">Download in progress</span>
                </div>
            </div>
        </div>

        <div class="threedViewer structureContainer filterWrapper">
            <div style="position: relative">
            <input
                #filterBox2
                class="vf-form__input searchLine"
                autocomplete="off"
                placeholder="Search species"
                (keyup.enter)="filterTable(filterBox2.value, 'afdb')"
                id="filteritemAFDB"
                [(value)]="filteritemAFDB"
            />
            <span
                *ngIf="filterBox2.value === ''"
                class="filtericon"
                (click)="filterTable(filterBox2.value, 'afdb')"
            >
                <img src="assets/img/Search.svg" alt="filter" />
            </span>
    
            <span
                *ngIf="filterBox2.value !== ''"
                class="filtericon"
                (click)="clearFilter('afdb')"
            >
                <img src="assets/img/crossicon.svg" alt="filter" />
            </span>
            </div>
        </div>
    </div>

    <div *ngIf="afdbZeroResultsMsg === '' && !isDatabaseErrorATBC">
        <table
            mat-table
            [dataSource]="afdbStructureDataSource"
            class="mat-elevation-z8 structureTable"
            matSort
            matSortActive="evalue"
            matSortDirection="desc"
            (matSortChange)="sortTable($event, 'afdb')"
            matSortDisableClear
            multiTemplateDataRows
        >

        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef class="nonMobile">
              <input
                type="checkbox"
                id="select-all-checkbox"
                class="vf-form__checkbox"
                [checked]="allSelectedATBC()"
                [disabled]="isLimitReachedATBC"
                
                (change)="toggleSelectAllEntries($event, 'afdb')"
              />
              <label for="select-all-checkbox" class="vf-form__label"></label>
            </th>
            <td mat-cell *matCellDef="let element" class="nonMobile">
                <input
                type="checkbox"
                id="row-checkbox-{{ element.targetToShow }}"
                class="vf-form__checkbox"
                [checked]="selectionATBC.has(element.targetToShow)"
                [disabled]="isRowCheckboxDisabledAFDB() && !selectionATBC.has(element.targetToShow)"
                (change)="toggleSingleRowSelection($event, element.targetToShow, 'afdb')"
              />
              <label for="row-checkbox-{{ element.targetToShow }}" class="vf-form__label"></label>
            </td>
        </ng-container>


        <ng-container matColumnDef="expand">
            <th  class="firstexpand arrow" mat-header-cell *matHeaderCellDef></th>
            <td  mat-cell *matCellDef="let element" class="arrow-box" [ngClass]="!isExpandedAFDB(element) ? '' : 'arrow-active'">
                <div class="nonMobile">
                    <button (click)="toggleRowAFDB(element); $event.stopPropagation()"  mat-icon-button aria-label="expand row" class="nonMobile icon-button">
                        <img *ngIf="!isExpandedAFDB(element)" src="assets/img/ep_arrow-up-bold.svg" alt="uparrow" class="unchecked-icon">
                        <img *ngIf="isExpandedAFDB(element)" src="assets/img/arrow_drop_down_24px.svg" alt="downarrow" class="unchecked-icon">
                    </button>
                </div>
                <div class="mobile-view">
                    <div class="mobile-wrapfirsttd">
                        <button (click)="toggleRowAFDB(element); $event.stopPropagation()"  mat-icon-button aria-label="expand row" class="icon-button">
                            <span *ngIf="!isExpandedAFDB(element)" class="mobile-arrow-title-text"> Open pairwise alignment  <img *ngIf="!isExpandedAFDB(element)" src="assets/img/down-arrow.svg" alt="uparrow" class="newimg"></span>
                            <span *ngIf="isExpandedAFDB(element)" class="mobile-arrow-title-text"> Close pairwise alignment   <img  src="assets/img/arrow-dropping.svg" alt="downarrow" class="newimg"></span>

                        </button>

                        <div class="mobile-align-3d">
                            <span class="mobile-arrow-title align3d-for-mobile"> Align in 3D </span>
                                <div class="switch-af">
                                    <input type="checkbox" [disabled]="disabledState[element.afdbAccessions.split('*')[0]] || false" [checked]="checkboxState[element.afdbAccessions.split('*')[0]] || false" id="{{element.afdbAccessions.split('*')[0]}}" value="{{element.afdbAccessions.split('*')[0]}}" (change)="clickToggleSuperpose($event,element.afdbAccessions.split('*')[0])" />
                                    <label for="{{element.afdbAccessions.split('*')[0]}}">
                                    
                                    <img src="../../assets/img/FatX.svg" alt="FatX" class="unchecked-icon">
                                    <img src="../../assets/img/base-switch_icon.svg" alt="check" class="checked-icon">

                                    </label>
                                </div>
                        </div>
                    </div>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetailAFDB">
            <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsAFDBStructure.length">
              <div class="example-element-detail" *ngIf="isExpandedAFDB(element)">
                <app-sequence-card [hsps]="element.hsps" [isExpandStructure]="true"></app-sequence-card>
              </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="afdbAccessions">
            <th class="first" mat-header-cell *matHeaderCellDef>
                <div style="display: flex; align-items: center; flex-direction: row;">
                    <span> AFDB accession</span>
                </div> 
            </th>
            <td mat-cell *matCellDef="let element" style="width:35%">
            <span class="mobile-view mobile-view-title"> AFDB accession</span>

            <div class="target-desc mobile-view">
                <span
                    class="titleBadges"
                    *ngIf="element.afdbAccessions !== 'Unavailable'">
                    <a (click)= "gaService.eventEmitter(
                'foldseek_clickthrough', 'FS_similar_structures', 'click', 'foldseek_AFDB_urls', 'Clicks on and AFDB accession URL in the foldseek results table')" class='accessLink' href="{{element.refLinkId}}" target="_blank">{{ element.targetToShow }} </a>
                    <!-- <app-entry-status [isSummary]="false" [clusterTable]="true" [isProteome]="element.afdbAccessions.split('*')[1]" [isReviewed]="element.afdbAccessions.split('*')[2]"></app-entry-status> -->
                    
                </span>
                <!-- <div class="descEllipsestrict">
                    {{  element.uniprotDescriptions }}
                </div> -->
            </div>
            

            <div class="target-desc nonMobile">
                <span
                    class="titleBadges"
                    *ngIf="element.afdbAccessions !== 'Unavailable'">
                    <a (click)= "gaService.eventEmitter(
                'foldseek_clickthrough', 'FS_similar_structures', 'click', 'foldseek_AFDB_urls', 'Clicks on and AFDB accession URL in the foldseek results table')" class='accessLink' href="{{element.refLinkId}}" target="_blank">{{ element.targetToShow }}</a>
                    <!-- <app-entry-status [isSummary]="false" [clusterTable]="true" [isProteome]="element.afdbAccessions.split('*')[1]" [isReviewed]="element.afdbAccessions.split('*')[2]"></app-entry-status> -->
                    
                </span>
                <!-- <div class="label-tooltip" *ngIf="element.uniprotDescriptions.length > 25">
            
                    <p class="descEllipse">{{ element.uniprotDescriptions.slice(0,25) }}... </p>
                    <span class="label-tooltip-text">
                    {{  element.uniprotDescriptions }}
                    </span>
                </div>
    
                <div *ngIf="element.uniprotDescriptions.length <= 25" class="descEllipsestrict">
                    {{  element.uniprotDescriptions }}
                </div> -->
            </div>
        </td>
        </ng-container>

        <ng-container matColumnDef="speciesNames">
            <th class="third-species" mat-header-cell *matHeaderCellDef>Species</th>
            <td mat-cell *matCellDef="let element">
           
            <span class="mobile-view mobile-view-title">Species</span>
            <span class="mobile-view"> <i>{{  element.speciesNames }}</i> </span>
            
            <span class="nonMobile">
                <div class="label-tooltip" *ngIf="element.speciesNames.length > 20">
               
                    <p class="descEllipseSpec"><i>{{ element.speciesNames.slice(0,20) }}... </i> </p>
                    <span class="label-tooltip-text">
                    {{  element.speciesNames }}
                    </span>
                </div>
    
                <div *ngIf="element.speciesNames.length <= 20">
                    <p class="descEllipseSpec-norm"><i> {{  element.speciesNames }}</i></p>
                </div>
            </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="sequenceLength">
            <th class="fourth" mat-header-cell *matHeaderCellDef>
            Residue <br/>range
            </th>
            <td mat-cell *matCellDef="let element">
            <span class="mobile-view mobile-view-title">Residue range</span>
            {{ element.sequenceLength }}
            </td>
        </ng-container>

        <ng-container matColumnDef="evalue">
            <th class="eval" mat-header-cell *matHeaderCellDef mat-sort-header="evalue">
                E-value
                <div class="label-tooltip" style="display: flex; flex-direction: row;">
                    <svg class="que-svg" viewBox="0 0 24 24">
                    <path fill="#373A36"
                            d="M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z"/>
                    </svg>
                    <span class="label-header-tooltip-text" style="font-size: 14px; font-weight: 400; text-align: left;">
                        Likelihood of a match between <br>the query and target sequence <br> in a structural alignment. <br>The lower the E-value, the more<br> significant the alignment. 
                     </span>
                </div>
            </th>
            <td mat-cell *matCellDef="let element">
                <span class="mobile-view mobile-view-title">
                    <div style="display: flex; flex-direction: row;">
                        E-value
                        <div class="label-tooltip">
                            <svg class="que-svg" viewBox="0 0 24 24">
                                <path fill="#373A36"
                                        d="M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z"/>
                            </svg>
                            <span class="label-header-tooltip-text" style="font-size: 14px; font-weight: 400; text-align: left;">
                                Likelihood of a match between <br>the query and target sequence <br> in a structural alignment. <br>The lower the E-value, the more<br> significant the alignment. 
                            </span>
                        </div>
                    </div>
                </span>
                {{ element.evalue }}
            </td>
        </ng-container>

        <ng-container matColumnDef="sequenceIdentity">
            <th class="fourth thirdid" mat-header-cell *matHeaderCellDef  mat-sort-header>
                <div style="display: flex; flex-direction: row; align-items:end;">
                    Seq. <br> identity
                    <div class="label-tooltip">
                        <svg class="que-svg" viewBox="0 0 24 24">
                        <path fill="#373A36"
                                d="M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z"/>
                        </svg>
                        <span class="label-header-tooltip-text" style="font-size: 14px; font-weight: 400; text-align: left;">
                            Percentage of identical <br>residues between aligned <br>sequences over the<br> aligned length.
                        </span>
                    </div>
                </div>
            </th>
            <td mat-cell *matCellDef="let element">
            <span class="mobile-view mobile-view-title">
                <div style="display: flex; flex-direction: row; align-items:end;">
                Seq. identity
                    <div class="label-tooltip">
                        <svg class="que-svg" viewBox="0 0 24 24">
                        <path fill="#373A36"
                                d="M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z"/>
                        </svg>
                        <span class="label-header-tooltip-text" style="font-size: 14px; font-weight: 400; text-align: left;">
                            Percentage of identical <br>residues between aligned <br>sequences over the<br> aligned length.
                        </span>
                    </div>
                </div>
            </span>
            {{ element.sequenceIdentity }}%
            </td>
        </ng-container>

        <ng-container matColumnDef="averagePlddt">
            <th class="fifth" mat-header-cell *matHeaderCellDef>
            Average <br/>pLDDT
            </th>
            <td mat-cell *matCellDef="let element">
            <span class="mobile-view mobile-view-title"> Average pLDDT</span>
            {{ element.averagePlddt }}
            </td>
        </ng-container>
    
        <ng-container matColumnDef="alighin3D">
            <th class="fifth alignin3d" mat-header-cell *matHeaderCellDef>
                Align <br/>in 3D
            </th>
            <td mat-cell *matCellDef="let element" class="align3dfor-nonmobile">
                
                <div class="switch-af nonMobile">
                    <input type="checkbox" [disabled]="disabledState[element.afdbAccessions.split('*')[0]] || false" [checked]="checkboxState[element.afdbAccessions.split('*')[0]] || false" id="{{element.afdbAccessions.split('*')[0]}}" value="{{element.afdbAccessions.split('*')[0]}}" (mousedown)="$event.stopPropagation()" 
                    (click)="$event.stopPropagation()"  (change)="clickToggleSuperpose($event,element.afdbAccessions.split('*')[0]); $event.stopPropagation();" />
                    <label for="{{element.afdbAccessions.split('*')[0]}}">
                    
                    <img src="../../assets/img/FatX.svg" alt="FatX" class="unchecked-icon">
                    <img src="../../assets/img/base-switch_icon.svg" alt="check" class="checked-icon">

                    </label>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsAFDBStructure"></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumnsAFDBStructure;"
            class="example-element-row"
            [ngClass]="isExpandedAFDB(element) ? 'example-expanded-row' : ''" 
            
            (click)="expandRowAFDB(element)">
        </tr>
      
        <tr mat-row *matRowDef="let row; columns: ['expandedDetailAFDB']" class="example-detail-row"></tr>

        <ng-container *ngFor="let row of afdbStructureDataSource?.data">
            <ng-container *ngIf="isExpandedAFDB(row)" >
              <tr mat-row *matRowDef="let row; columns: ['expandedDetailAFDB']; when: isExpansionDetailRowAFDB" class="example-detail-row"></tr>
            </ng-container>
          </ng-container>
        </table>
    
    </div>
   
    <div  *ngIf="afdbZeroResultsMsg === ''  && !isDatabaseErrorATBC" class="threedViewer structureContainer mobile-error-msg fullwidth">
        <p class="noRecMsg">{{ errorAFDB }}</p>
    </div>
    
    <div *ngIf="afdbZeroResultsMsg === ''  && !isDatabaseErrorATBC" [ngClass]="errorAFDB ? 'nonMobile' : ''">
        <mat-paginator
        [length]="totalAFDBStructure"
        [pageSize]="recordsAFDB"
        [pageIndex]="currentAFDBPage"
        [pageSizeOptions]="[5, 10, 25, 50, 100]"
        aria-label="Select page"
        (page)="handlePageEvent($event,'afdb')"
      >
      </mat-paginator>
    </div>
